import { Component } from '@angular/core';
import { FirebaseApp } from '@angular/fire';
import { Plugins } from '@capacitor/core';
const { SplashScreen } = Plugins;
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { HistoryHelperService } from './utils/history-helper.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: [
    './side-menu/styles/side-menu.scss',
    './side-menu/styles/side-menu.shell.scss',
    './side-menu/styles/side-menu.responsive.scss'
  ]
})
export class AppComponent {
  appPages = [
    {
      title: 'MENU_STALLIONLIST',
      url: '/stallion',
      ionicIcon: 'list-outline'
    },
    {
      title: 'MENU_IMPRINT',
      url: '/imprint',
      ionicIcon: 'book-outline'
    },
    {
      title: 'MENU_CONTACT',
      url: '/contactus',
      ionicIcon: 'mail-outline'
    },
    {
      title: 'MENU_ADVERTISESTALLIONS',
      url: '/members/crud/listing',
      ionicIcon: 'lock-closed-outline'
    }

  ];
  accountPages = [
  ];

  textDir = 'ltr';

  // Inject HistoryHelperService in the app.components.ts so its available app-wide
  constructor(
    public translate: TranslateService,
    public historyHelper: HistoryHelperService,
  ) {
    this.initializeApp();
    this.setLanguage();
  }

  async initializeApp() {
    try {
     await SplashScreen.hide();
    } catch (err) {
     console.log('This is normal in a browser', err);
    }
  }

  setLanguage() {
    // this language will be used as a fallback when a translation isn't found in the current language
    //this.translate.setDefaultLang('en');
    var lang: string = this.translate.getBrowserLang();
    console.log(lang);
    this.translate.setDefaultLang("en");

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use(lang);

    // this is to determine the text direction depending on the selected language
    // for the purpose of this example we determine that only arabic and hebrew are RTL.
    // this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
    //   this.textDir = (event.lang === 'ar' || event.lang === 'iw') ? 'rtl' : 'ltr';
    // });
  }

}
